"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledSvg = _styledComponents.default.svg.attrs({
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    path + path {\n        fill: ", "\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var SpinnerIcon = function SpinnerIcon() {
  return /*#__PURE__*/_react.default.createElement(StyledSvg, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 0L8.11664 0.00671387C8.61398 0.0644789 9 0.487164 9 1C9 1.55228 8.55229 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8L14.0067 7.88336C14.0645 7.38602 14.4872 7 15 7C15.5523 7 16 7.44771 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0Z",
    fill: "#E8DBE9",
    opacity: "0.4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.7263 10.0692L15.6896 10.1801C15.5051 10.6456 14.9969 10.909 14.5016 10.7763C13.9681 10.6334 13.6515 10.085 13.7945 9.55157C14.6521 6.35077 12.7526 3.06075 9.55183 2.2031C6.35103 1.34545 3.06101 3.24494 2.20336 6.44574C1.34571 9.64653 3.24521 12.9366 6.446 13.7942L6.55693 13.8309C7.02237 14.0154 7.28584 14.5236 7.15311 15.019C7.01017 15.5524 6.46183 15.869 5.92836 15.7261C1.66064 14.5825 -0.872025 10.1958 0.27151 5.9281C1.41504 1.66037 5.80174 -0.87229 10.0695 0.271245C14.3372 1.41478 16.8699 5.80147 15.7263 10.0692Z"
  }, /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "xml",
    dur: "1s",
    from: "0 8 8",
    repeatCount: "indefinite",
    to: "360 8 8",
    type: "rotate"
  })));
};
var _default = exports.default = SpinnerIcon;